module.exports = __webpack_public_path__ + "static/media/mike-mail.f3419d3b.weba";